import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, unit_type, record_type, bool_type, union_type, array_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Service_$reflection, Service, Machine_$reflection, CustomerInfo_$reflection } from "../Shared/ApiDataTypes.js";
import { contains as contains_1, choose, unzip, tryPick, pick, map as map_1, tryFind, tryHead, append as append_1, take, updateAt, mapIndexed, collect } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { createDisposable, useEffectDisposableOnce, forwardRef } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TablePagination, TableContainer, TableBody, Link, TableHead, TableRow, Table as Table_1, TableSortLabel, TableCell, Alert, Button, DialogActions, Checkbox, FormControlLabel, FormGroup, FormLabel, FormControl, Typography, Grid, DialogContent, DialogTitle, Dialog, IconButton, ButtonGroup, Collapse, Autocomplete, TextField } from "@mui/material";
import { toArray, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { email as email_1 } from "../Shared/Validate.js";
import { int32ToString, equals, uncurry2, structuralHash, createObj, defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { some, unwrap, bind, value as value_155, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { tryStr, Tickets_Severity__get_BackgroundColor, Tickets_Severity__get_ColorCode, Tickets_Severity__ToString_12C6553D, strIContains, ServiceType__ToString_12C6553D, Machine_getNameOrCode, DateOnly_tryParse, DateOnly_now, DateOnly_iso, Tickets_Severity, ServiceStatus, ServiceType } from "../Shared/Shared.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import Remove from "@mui/icons-material/Remove";
import Add from "@mui/icons-material/Add";
import { singleton as singleton_1, cons, empty as empty_2, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultOf as defaultOf_1 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Activities_TypeSelection_351560E3 } from "../Components/Activities/TypeSelection.js";
import { Activities_SeveritySelection_49984EA } from "../Components/Activities/SeveritySelection.js";
import { Activities_PlannedDatePicker_Z7A8C0D37 } from "../Components/Activities/PlannedDatePicker.js";
import { Activities_NotifyDatePicker_Z4AAA61F6 } from "../Components/Activities/NotifyDatePicker.js";
import Cancel from "@mui/icons-material/Cancel";
import { description } from "../Components/Activities/Helpers.js";
import { onPageChange, skeletonRows, loadingIndicator, loadingIndicatorSmall } from "../ViewHelpers.js";
import { API_Machine_Service } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import Delete from "@mui/icons-material/Delete";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import Done from "@mui/icons-material/Done";
import { sortFn, useResponsive } from "../Utils.js";
import { Components_Searchbar_25F45B5E } from "../Components/Searchbar.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { Components_Chip_51BC9844 } from "../Components/Chip.js";
import Warning from "@mui/icons-material/Warning";
import { toDateOnlyStr } from "../Locale.js";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Activities_StatusChip_2E7B7895 } from "./StatusChip.js";
import { Components_ActivityEditButton_Z48ACC4F1 } from "../Components/Activities/ActivityEditButton.js";

export class Target extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Group", "Customer", "Machine"];
    }
}

export function Target_$reflection() {
    return union_type("Kundeweb.Activities.Target", [], Target, () => [[["Item1", int32_type], ["Item2", array_type(CustomerInfo_$reflection())]], [["groupId", int32_type], ["customerId", int32_type], ["Item3", CustomerInfo_$reflection()]], [["groupId", int32_type], ["customerId", int32_type], ["machineId", int32_type], ["Item4", Machine_$reflection()]]]);
}

export function Target__RequestPath(this$) {
    switch (this$.tag) {
        case 1:
            return `/api/customer/${this$.fields[1]}/activities`;
        case 2:
            return `/api/machine/${this$.fields[2]}/services`;
        default:
            return `/api/customer-group/${this$.fields[0]}/activities`;
    }
}

export function Target__ToCustomerOpt(this$) {
    switch (this$.tag) {
        case 1:
            return this$.fields[2];
        case 2:
            return undefined;
        default:
            return undefined;
    }
}

export function Target__ToCustomersOpt(this$) {
    switch (this$.tag) {
        case 1:
            return undefined;
        case 2:
            return undefined;
        default:
            return this$.fields[1];
    }
}

export function Target__ToMachineOpt(this$) {
    switch (this$.tag) {
        case 1:
            return undefined;
        case 2:
            return this$.fields[3];
        default:
            return undefined;
    }
}

export function Target__ToMachines(this$) {
    switch (this$.tag) {
        case 0:
            return collect((customer) => customer.Machines, this$.fields[1]);
        case 1:
            return this$.fields[2].Machines;
        default:
            return [];
    }
}

const EmailInput = forwardRef((tupledArg) => {
    const _arg = tupledArg[0];
    const key = _arg[0] | 0;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setError = patternInput[1];
    const error = patternInput[0];
    return MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["key", `email-input-${key}`]), delay(() => append(singleton(["onFocus", (_arg_1) => {
        setError(false);
    }]), delay(() => append(singleton(["onBlur", (ev) => {
        const email = ev.target.value;
        if (isNullOrWhiteSpace(email)) {
            setError(false);
        }
        else if (email_1(email)) {
            _arg[1](email);
            setError(false);
        }
        else {
            setError(true);
        }
    }]), delay(() => append(singleton(["variant", "standard"]), delay(() => append(singleton(["inputRef", (elem) => {
        tupledArg[1].current[key] = elem;
    }]), delay(() => append(singleton(["type", "email"]), delay(() => append(singleton(["error", error]), delay(() => append(singleton(["label", ctx.Locale.t("Login.Email")]), delay(() => (error ? singleton(["helperText", ctx.Locale.t("Services.Errors.InvalidEmail")]) : empty_1()))))))))))))))))))));
});

function machineAutocomplete(locale, error, machineIds, serviceTicket, onChange) {
    return MuiHelpers_createElement(Autocomplete, [["options", Array.from(machineIds)], ["value", (serviceTicket.MachineId < 0) ? defaultOf() : [serviceTicket.MachineId, serviceTicket.MachineName, serviceTicket.MachineCode]], ["isOptionEqualToValue", (tupledArg) => ((tupledArg_1) => (tupledArg[0] === tupledArg_1[0]))], ["getOptionLabel", (tupledArg_2) => {
        const itemName = tupledArg_2[1];
        if (isNullOrWhiteSpace(itemName)) {
            return `*${tupledArg_2[2]}`;
        }
        else {
            return itemName;
        }
    }], ["onChange", (_arg_5, v, _arg_1_1) => {
        const patternInput = defaultArg(v, [-2, "", ""]);
        onChange(patternInput[0], patternInput[1], patternInput[2]);
    }], ["renderInput", (props) => {
        const emptyMachineNameChosen = (serviceTicket.MachineId < 0) ? false : isNullOrWhiteSpace(serviceTicket.MachineName);
        return MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["label", locale.t("Machine")]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["error", error]), delay(() => (emptyMachineNameChosen ? singleton(["helperText", ["*" + locale.t("Services.MissingMachineName")]]) : (error ? singleton(["helperText", [locale.t("Services.Errors.MissingMachine")]]) : empty_1())))))))))))));
    }]]);
}

function otherTypeInput(locale, error, typeOpt, onUpdate) {
    let elements;
    return MuiHelpers_createElement(Collapse, [["in", defaultArg(map((_arg) => {
        if (_arg.tag === 17) {
            return true;
        }
        else {
            return false;
        }
    }, typeOpt), false)], (elements = [MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["variant", "standard"]), delay(() => append(singleton(["error", error]), delay(() => append(error ? singleton(["helperText", locale.t("Services.Errors.MissingOtherDesc")]) : empty_1(), delay(() => append(singleton(["label", locale.t("Other")]), delay(() => append(singleton(["disabled", defaultArg(map((_arg_1) => {
        if (_arg_1.tag === 17) {
            return false;
        }
        else {
            return true;
        }
    }, typeOpt), true)]), delay(() => append(singleton(["value", defaultArg(map((_arg_2) => {
        if (_arg_2.tag === 17) {
            return _arg_2.fields[0];
        }
        else {
            return "";
        }
    }, typeOpt), "")]), delay(() => singleton(["onChange", (e) => {
        const str_1 = e.target.value;
        onUpdate(map((type$0027) => {
            if (type$0027.tag === 17) {
                return new ServiceType(17, [str_1]);
            }
            else {
                return type$0027;
            }
        }, typeOpt));
    }]))))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

function EmailInputList(emailInputListInputProps) {
    let elems_3, elements_2, elements, props_1, elements_1, props_4;
    const emailRefs = emailInputListInputProps.emailRefs;
    const notify = emailInputListInputProps.notify;
    let patternInput;
    const initial = [[0, ""]];
    patternInput = reactApi.useState(initial);
    const setEmails = patternInput[1];
    const emails = patternInput[0];
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        flexGrow: 0,
        flexBasis: 50 + "%",
        gap: 20 + "px ",
    }], (elems_3 = [mapIndexed((emailIdx, _arg) => EmailInput([[emailIdx, (email) => {
        console.debug("Email:", email);
        setEmails(updateAt(emailIdx, [emailIdx, email], emails));
    }], emailRefs]), emails), MuiHelpers_createElement(ButtonGroup, [["size", "small"], (elements_2 = [MuiHelpers_createElement(IconButton, [["onClick", (_arg_1) => {
        const newLen = (emails.length - 1) | 0;
        const newEmails = take(newLen, emails);
        emailRefs.current = take(newLen, emailRefs.current);
        setEmails(newEmails);
    }], ["disabled", !notify ? true : (emails.length < 2)], (elements = [(props_1 = {}, react.createElement(Remove, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(IconButton, [["onClick", (_arg_2) => {
        let array_3;
        const newEmails_1 = append_1(emails, [[emails.length, ""]]);
        emailRefs.current = ((array_3 = [undefined], append_1(emailRefs.current, array_3)));
        setEmails(newEmails_1);
    }], ["disabled", !notify], (elements_1 = [(props_4 = {}, react.createElement(Add, props_4))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export class CreationErrors extends Record {
    constructor(Customer, Machine, Type, OtherType) {
        super();
        this.Customer = Customer;
        this.Machine = Machine;
        this.Type = Type;
        this.OtherType = OtherType;
    }
}

export function CreationErrors_$reflection() {
    return record_type("Kundeweb.Activities.CreationErrors", [], CreationErrors, () => [["Customer", bool_type], ["Machine", bool_type], ["Type", bool_type], ["OtherType", bool_type]]);
}

export function customerAutocomplete(locale, errors, onChange, customers, chosenCustomer) {
    return MuiHelpers_createElement(Autocomplete, [["value", defaultArg(chosenCustomer, defaultOf())], ["options", Array.from(customers)], ["isOptionEqualToValue", (customerOpt) => ((selected) => (customerOpt.Id === selected.Id))], ["getOptionLabel", (item) => item.Name], ["onChange", (_arg, v, _arg_1) => {
        onChange(defaultArg(map((c) => c.Id, v), -1));
    }], ["renderInput", (props) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["label", locale.t("Customer.Customer")]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["error", errors.Customer]), delay(() => (errors.Customer ? singleton(["helperText", locale.t("Services.Errors.MissingCustomer")]) : empty_1()))))))))))))]]);
}

/**
 * You can either create a new service on the machine, or from the customer view.
 */
export function CreationDialog(creationDialogInputProps) {
    let elements_11, elements_8, elements_7, elements, elements_1, elems_3, elems_2, props_8, elements_6, elements_5, elements_4, elems_6, elements_2, elems_8, elements_3, elements_10, elements_9;
    const onClose = creationDialogInputProps.onClose;
    const isOpen = creationDialogInputProps.isOpen;
    const machines = creationDialogInputProps.machines;
    const machineOpt = creationDialogInputProps.machineOpt;
    const customersOpt = creationDialogInputProps.customersOpt;
    const ctx = reactApi.useContext(ctx_1);
    const initService = new Service(-1, defaultArg(map((sess) => sess.UserId, ctx.Session), -1), ["", ""], new ServiceStatus(0, []), "", new Tickets_Severity(4, []), undefined, "", "", -1, "", defaultArg(map((m) => m.Id, machineOpt), -1), defaultArg(map((m_1) => m_1.Name, machineOpt), ""), defaultArg(map((m_2) => m_2.Code, machineOpt), ""), undefined, true, [""], false, [""], DateOnly_iso(DateOnly_now()), undefined, undefined);
    const patternInput = reactApi.useState(initService);
    const setNewServiceTicket = patternInput[1];
    const newServiceTicket = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setUploading = patternInput_1[1];
    const customerEmailRefs = reactApi.useRef([]);
    const internalEmailRefs = reactApi.useRef([]);
    let patternInput_2;
    const initial_2 = new CreationErrors(false, false, false, false);
    patternInput_2 = reactApi.useState(initial_2);
    const setErrors = patternInput_2[1];
    const errors = patternInput_2[0];
    const dependencies = [machineOpt];
    reactApi.useEffect(() => {
        if (machineOpt != null) {
            const m_3 = value_155(machineOpt);
            setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, m_3.Id, m_3.Name, m_3.Code, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
        }
    }, dependencies);
    const customersOpt_1 = map((array) => array.filter((customer) => customer.EnableServices), customersOpt);
    const customerOpt = bind((customers) => {
        if (customers.length === 1) {
            return tryHead(customers);
        }
        else {
            return tryFind((customer_1) => (customer_1.Id === newServiceTicket.CustomerId), customers);
        }
    }, customersOpt_1);
    const machineIds = map_1((machine_1) => [machine_1.Id, machine_1.Name, machine_1.Code], machines.filter((machine) => {
        if (customerOpt == null) {
            return defaultArg(map((array_5) => array_5.some((customer_3) => customer_3.Machines.some((customerMachine) => (customerMachine.Id === machine.Id))), customersOpt_1), true);
        }
        else {
            return defaultArg(map((customer_2) => customer_2.Machines.some((m_4) => (m_4.Id === machine.Id)), customerOpt), true);
        }
    }));
    const plannedDate = DateOnly_tryParse(newServiceTicket.PlannedDate);
    const handleClose = (activityOpt) => {
        onClose(activityOpt);
        const pr = new Promise(resolve => setTimeout(resolve, 150));
        pr.then(() => {
            setErrors(new CreationErrors(false, false, false, false));
            setNewServiceTicket(initService);
        });
    };
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["maxWidth", "md"], ["onClose", (_arg_2, v) => {
        if (v === "escapeKeyDown") {
        }
        handleClose(undefined);
    }], (elements_11 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Services.ServiceForm.CreateNew")]]), MuiHelpers_createElement(DialogContent, [["style", {
        maxHeight: 80 + "%",
        overflowY: "scroll",
    }], ["dividers", true], (elements_8 = [MuiHelpers_createElement(Grid, [["container", true], ["spacing", 4], (elements_7 = [MuiHelpers_createElement(Grid, [["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], ["item", true], ["xs", 12], ["sm", 6], (elements = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        }], (elems = [MuiHelpers_createElement(Typography, [["paragraph", true], ["variant", "body2"], ["children", ctx.Locale.t("Services.ServiceForm.Desc")]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue;
            return append((matchValue = customersOpt_1, (matchValue != null) ? singleton(customerAutocomplete(ctx.Locale, errors, (customerId) => {
                setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, customerId, newServiceTicket.Customer, -1, "", newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
                setErrors(new CreationErrors(false, errors.Machine, errors.Type, errors.OtherType));
            }, matchValue, customerOpt)) : singleton(defaultOf_1())), delay(() => {
                let matchValue_1, machine_2;
                return append((matchValue_1 = machineOpt, (matchValue_1 == null) ? singleton(machineAutocomplete(ctx.Locale, errors.Machine, machineIds, newServiceTicket, (machineId_2, machineName, machineCode) => {
                    setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, defaultArg(map((array_11) => pick((customer_4) => {
                        const customer_5 = customer_4;
                        return tryPick((cm) => {
                            if (cm.Id === machineId_2) {
                                return customer_5.Id;
                            }
                            else {
                                return undefined;
                            }
                        }, customer_5.Machines);
                    }, array_11), customersOpt_1), -1), newServiceTicket.Customer, machineId_2, machineName, machineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
                    setErrors(new CreationErrors(false, false, errors.Type, errors.OtherType));
                })) : ((machine_2 = matchValue_1, singleton(MuiHelpers_createElement(TextField, [["disabled", true], ["label", ctx.Locale.t("Machine")], ["value", Machine_getNameOrCode({
                    code: machine_2.Code,
                    name: machine_2.Name,
                })]]))))), delay(() => append(singleton(createElement(Activities_TypeSelection_351560E3, {
                    typeOpt: unwrap(newServiceTicket.Type),
                    onChange: (newType) => {
                        setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newType, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
                        if (errors.Type) {
                            setErrors(new CreationErrors(errors.Customer, errors.Machine, false, false));
                        }
                    },
                    error: errors.Type,
                })), delay(() => append(singleton(otherTypeInput(ctx.Locale, errors.OtherType, newServiceTicket.Type, (newType_1) => {
                    setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newType_1, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
                    if (errors.OtherType) {
                        setErrors(new CreationErrors(errors.Customer, errors.Machine, errors.Type, false));
                    }
                })), delay(() => append(singleton(createElement(Activities_SeveritySelection_49984EA, {
                    severity: newServiceTicket.Severity,
                    onChange: (newSeverity) => {
                        setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newSeverity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
                    },
                })), delay(() => singleton(MuiHelpers_createElement(TextField, [["variant", "outlined"], ["fullWidth", true], ["label", ctx.Locale.t("Ticket.VismaOrderNo")], ["multiline", false], ["value", newServiceTicket.VismaOrder], ["onChange", (e) => {
                    setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, e.target.value, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
                }]]))))))))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Grid, [["item", true], ["sm", 6], ["xs", 12], ["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], (elements_1 = [MuiHelpers_createElement(Typography, [["style", {
        marginBottom: 5,
    }], ["children", ctx.Locale.t("Services.PlannedDate")]]), createElement(Activities_PlannedDatePicker_Z7A8C0D37, {
        plannedDateOpt: unwrap(DateOnly_tryParse(newServiceTicket.PlannedDate)),
        onChange: (_arg_3) => {
            if (_arg_3 != null) {
                setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, DateOnly_iso(_arg_3), newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
            }
            else {
                console.error(some("Failure picking new date: %o"), newServiceTicket.PlannedDate);
            }
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
    }], (elems_2 = [createElement(Activities_NotifyDatePicker_Z4AAA61F6, {
        value: unwrap(bind(DateOnly_tryParse, newServiceTicket.NotifyDate)),
        maxDate: defaultArg(plannedDate, DateOnly_now()),
        onChange: (newDateOpt, _arg_4) => {
            setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, map(DateOnly_iso, newDateOpt), newServiceTicket.CompletedDate));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), MuiHelpers_createElement(IconButton, [["onClick", (_arg_5) => {
        setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, undefined, newServiceTicket.CompletedDate));
    }], ["size", "small"], ["disabled", newServiceTicket.NotifyDate == null], ["children", (props_8 = {}, react.createElement(Cancel, props_8))]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(Grid, [["item", true], ["xs", 12], (elements_6 = [description(ctx.Locale, newServiceTicket.Description, (desc) => {
        setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, desc, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
    }), MuiHelpers_createElement(FormControl, [["fullWidth", true], ["margin", "normal"], (elements_5 = [MuiHelpers_createElement(FormLabel, [["component", "legend"], ["children", ctx.Locale.t("Services.ServiceForm.Notify")]]), MuiHelpers_createElement(FormGroup, [["row", true], ["sx", {
        flexWrap: "nowrap",
        justifyContent: "space-around",
        gap: 10 + "px",
    }], (elements_4 = [createElement("div", createObj(ofArray([["style", {}], (elems_6 = [MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Services.ServiceForm.Internal")], ["onChange", (e_1) => {
        setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, e_1.target.checked, newServiceTicket.InternalRecipients, newServiceTicket.NotifyCustomers, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
    }], ["checked", newServiceTicket.NotifyInternally], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["size", "small"]])]]), MuiHelpers_createElement(Collapse, [["in", newServiceTicket.NotifyInternally], (elements_2 = [createElement(EmailInputList, {
        notify: newServiceTicket.NotifyInternally,
        emailRefs: internalEmailRefs,
    })], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {}], (elems_8 = [MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Services.ServiceForm.IncludeCustomer")], ["onChange", (e_2) => {
        setNewServiceTicket(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.InternalRecipients, e_2.target.checked, newServiceTicket.CustomerRecipients, newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
    }], ["checked", newServiceTicket.NotifyCustomers], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"], ["size", "small"]])]]), MuiHelpers_createElement(Collapse, [["in", newServiceTicket.NotifyCustomers], (elements_3 = [createElement(EmailInputList, {
        notify: newServiceTicket.NotifyCustomers,
        emailRefs: customerEmailRefs,
    })], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])])], ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elements_7))])])], ["children", reactApi.Children.toArray(Array.from(elements_8))])]), MuiHelpers_createElement(DialogActions, [(elements_10 = [MuiHelpers_createElement(Button, [["onClick", (_arg_6) => {
        handleClose(undefined);
    }], ["children", ctx.Locale.t("Close")]]), MuiHelpers_createElement(Button, [["onClick", (_arg_7) => {
        setUploading(true);
        const validateEmails = (emails) => unzip(choose((elemOpt) => bind((elem) => {
            const email = elem.value;
            const valid = email_1(email);
            if (!isNullOrWhiteSpace(email)) {
                return [valid, email];
            }
            else {
                return undefined;
            }
        }, elemOpt), emails));
        const patternInput_3 = validateEmails(internalEmailRefs.current);
        const patternInput_4 = validateEmails(customerEmailRefs.current);
        const customerValid = (customersOpt_1 == null) ? true : (newServiceTicket.CustomerId > 0);
        const machineValid = (newServiceTicket.MachineId > 0) && (!isNullOrWhiteSpace(newServiceTicket.MachineName) ? true : !isNullOrWhiteSpace(newServiceTicket.MachineCode));
        const typeValid = newServiceTicket.Type != null;
        const otherTypeValid = defaultArg(map((_arg) => {
            if (_arg.tag === 17) {
                return !isNullOrWhiteSpace(_arg.fields[0]);
            }
            else {
                return true;
            }
        }, newServiceTicket.Type), true);
        if (((((customerValid && machineValid) && typeValid) && otherTypeValid) && (!newServiceTicket.NotifyCustomers ? true : !contains_1(false, patternInput_4[0], {
            Equals: (x, y) => (x === y),
            GetHashCode: structuralHash,
        }))) && (!newServiceTicket.NotifyInternally ? true : !contains_1(false, patternInput_3[0], {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: structuralHash,
        }))) {
            handleClose(new Service(newServiceTicket.Id, newServiceTicket.CreatedById, newServiceTicket.CreatedBy, newServiceTicket.Status, newServiceTicket.ClosingComment, newServiceTicket.Severity, newServiceTicket.Type, newServiceTicket.Description, newServiceTicket.VismaOrder, newServiceTicket.CustomerId, newServiceTicket.Customer, newServiceTicket.MachineId, newServiceTicket.MachineName, newServiceTicket.MachineCode, newServiceTicket.TicketIdOpt, newServiceTicket.NotifyInternally, newServiceTicket.NotifyInternally ? patternInput_3[1] : [], newServiceTicket.NotifyCustomers, newServiceTicket.NotifyCustomers ? patternInput_4[1] : [], newServiceTicket.PlannedDate, newServiceTicket.NotifyDate, newServiceTicket.CompletedDate));
            console.debug("ServiceCreationDialog: finished creating new service");
        }
        else {
            console.error(some("ServiceCreationDialog: new service is not valid"));
            setErrors(new CreationErrors(!customerValid, !machineValid, !typeValid, !otherTypeValid));
        }
        setUploading(false);
    }], ["color", "primary"], (elements_9 = toList(delay(() => (patternInput_1[0] ? singleton(loadingIndicatorSmall()) : singleton(ctx.Locale.t("Add"))))), ["children", reactApi.Children.toArray(Array.from(elements_9))])])], ["children", reactApi.Children.toArray(Array.from(elements_10))])])], ["children", reactApi.Children.toArray(Array.from(elements_11))])]);
}

export function DeleteButton(deleteButtonInputProps) {
    let elements_4, elements, elements_1, elements_3, elems_4, children, elems_3, elements_2, props_12;
    const onClose = deleteButtonInputProps.onClose;
    const service = deleteButtonInputProps.service;
    const key = deleteButtonInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const isLoading = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setErrorMsg = patternInput_2[1];
    const errorMsg = patternInput_2[0];
    const activityTypeStr = defaultArg(map((t) => ServiceType__ToString_12C6553D(t, ctx.Language), service.Type), ctx.Locale.t("Other"));
    const machineNameOrCode = Machine_getNameOrCode({
        code: service.MachineCode,
        name: service.MachineName,
    });
    const handleClose = () => {
        setIsOpen(false);
    };
    const xs_2 = [MuiHelpers_createElement(Dialog, [["open", patternInput_1[0]], ["onClose", (_arg_3, v) => {
        if (v === "escapeKeyDown") {
        }
        handleClose();
    }], (elements_4 = [MuiHelpers_createElement(DialogTitle, [(elements = [ctx.Locale.t("Services.DeleteActivityTypeOnMachine", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})((((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["activityType", activityTypeStr])),["machineName", machineNameOrCode]))], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(DialogContent, [["dividers", true], (elements_1 = [MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Services.DeleteConfirmation")]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(DialogActions, [(elements_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexGrow: 1,
    }], (elems_4 = [(children = toList(delay(() => {
        if (errorMsg != null) {
            const err_1 = errorMsg;
            return singleton(MuiHelpers_createElement(Alert, [["severity", "error"], ["style", {
                alignSelf: "flex-start",
            }], ["children", err_1]]));
        }
        else {
            return singleton(defaultOf_1());
        }
    })), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("div", createObj(singleton_1((elems_3 = [MuiHelpers_createElement(Button, [["disabled", isLoading], ["onClick", (_arg_4) => {
        handleClose();
    }], ["children", ctx.Locale.t("Cancel")]]), MuiHelpers_createElement(Button, [["color", "secondary"], ["disabled", errorMsg != null], ["onClick", (_arg_5) => {
        let properties_2;
        setLoading(true);
        const url = API_Machine_Service(service.MachineId, service.Id);
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(unit_type, undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_2()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(unit_type, unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => (Promise.resolve(new FSharpResult$2(0, [void undefined]))))))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            setLoading(false);
            if (res.tag === 0) {
                handleClose();
                onClose(service);
            }
            else {
                console.error(some(`Could not delete activity #${service.Id}:`), res.fields[0]);
                setErrorMsg(ctx.Locale.t("Services.DeleteFail"));
            }
        });
    }], (elements_2 = toList(delay(() => (isLoading ? singleton(loadingIndicator()) : singleton(ctx.Locale.t("Delete"))))), ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])]), MuiHelpers_createElement(IconButton, [["key", key], ["onClick", (ev) => {
        ev.preventDefault();
        console.debug("Asking to delete activity:", service);
        setErrorMsg(undefined);
        setIsOpen(true);
    }], ["size", "small"], ["children", (props_12 = {}, react.createElement(Delete, props_12))]])];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function UpdateButton(updateButtonInputProps) {
    let props_1;
    const onUpdate = updateButtonInputProps.onUpdate;
    const service = updateButtonInputProps.service;
    const key = updateButtonInputProps.$key;
    const patternInput = reactApi.useState(false);
    const setUploading = patternInput[1];
    return MuiHelpers_createElement(IconButton, [["key", key], ["onClick", (ev) => {
        let properties_2;
        ev.preventDefault();
        const requestPath = API_Machine_Service(service.MachineId, service.Id);
        setUploading(true);
        let pr_1;
        const data = some(Auto_generateBoxedEncoder_437914C6(Service_$reflection(), undefined, undefined, undefined)(service));
        const decoder = Auto_generateBoxedDecoder_Z6670B51(Service_$reflection(), undefined, undefined);
        const data_1 = data;
        const caseStrategy_3 = undefined;
        const extra_3 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_2()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(requestPath, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Service_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            onUpdate(res);
            setUploading(false);
        });
    }], ["size", "small"], ["children", patternInput[0] ? loadingIndicatorSmall() : ((props_1 = {}, react.createElement(Done, props_1)))]]);
}

export function actionHeader(div, t) {
    return MuiHelpers_createElement(TableCell, toList(delay(() => append(singleton(["variant", "head"]), delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["padding", "checkbox"]), delay(() => append(singleton(["align", "center"]), delay(() => append(div ? singleton(["component", "div"]) : empty_1(), delay(() => singleton(["children", t]))))))))))))));
}

export function td(div, children) {
    return MuiHelpers_createElement(TableCell, toList(delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["variant", "body"]), delay(() => append(div ? singleton(["component", "div"]) : empty_1(), delay(() => singleton(["children", children]))))))))));
}

export function iconHeader(t) {
    return MuiHelpers_createElement(TableCell, [["variant", "head"], ["size", "small"], ["align", "center"], ["children", t]]);
}

export function iconCell(children) {
    let elements;
    return MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["align", "center"], (elements = [createElement("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    })], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function ConfirmDateButton(confirmDateButtonInputProps) {
    const callback = confirmDateButtonInputProps.callback;
    const service = confirmDateButtonInputProps.service;
    let mounted = false;
    const patternInput = reactApi.useState(false);
    const setUpdating = patternInput[1];
    useEffectDisposableOnce(() => {
        mounted = true;
        return createDisposable(() => {
            console.debug("LoadingIconButton dispose");
            mounted = false;
        });
    });
    if (patternInput[0]) {
        return loadingIndicatorSmall();
    }
    else {
        return MuiHelpers_createElement(Checkbox, [["color", "primary"], ["checked", equals(service.Status, new ServiceStatus(1, []))], ["onChange", (ev) => {
            let properties_2;
            setUpdating(true);
            ev.preventDefault();
            const updatedService = new Service(service.Id, service.CreatedById, service.CreatedBy, (ev.target.checked) ? (new ServiceStatus(1, [])) : (new ServiceStatus(0, [])), service.ClosingComment, service.Severity, service.Type, service.Description, service.VismaOrder, service.CustomerId, service.Customer, service.MachineId, service.MachineName, service.MachineCode, service.TicketIdOpt, service.NotifyInternally, service.InternalRecipients, service.NotifyCustomers, service.CustomerRecipients, service.PlannedDate, service.NotifyDate, service.CompletedDate);
            const url = API_Machine_Service(updatedService.MachineId, updatedService.Id);
            let pr_1;
            const data = some(Auto_generateBoxedEncoder_437914C6(Service_$reflection(), undefined, undefined, undefined)(updatedService));
            const decoder = Auto_generateBoxedDecoder_Z6670B51(Service_$reflection(), undefined, undefined);
            const data_1 = data;
            const caseStrategy_3 = undefined;
            const extra_3 = undefined;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_2()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Service_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_1.then((res) => {
                if (res.tag === 0) {
                    callback(res.fields[0]);
                }
                else {
                    console.error(some("Failed updating service:"), res.fields[0]);
                }
                if (mounted) {
                    setUpdating(false);
                }
            });
        }]]);
    }
}

/**
 * Table view of the given services, with add and edit button included.
 */
export function Table(tableInputProps) {
    let elems_13;
    const updateCallback = tableInputProps.updateCallback;
    const deleteCallback = tableInputProps.deleteCallback;
    const addCallback = tableInputProps.addCallback;
    const services = tableInputProps.services;
    const loading = tableInputProps.loading;
    const target = tableInputProps.target;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const showClosed = patternInput[0];
    const patternInput_1 = reactApi.useState("");
    const searchStr = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const asc = patternInput_2[0];
    const patternInput_3 = reactApi.useState("PlannedDate");
    const sortKey = patternInput_3[0];
    const patternInput_4 = reactApi.useState(0);
    const setPage = patternInput_4[1];
    const page = patternInput_4[0] | 0;
    const patternInput_5 = reactApi.useState(5);
    const rowsPerPage = patternInput_5[0] | 0;
    const rowsPerPageOptions = new Int32Array([5, 10, 15, 20]);
    const responsive = useResponsive(undefined);
    const isBig = (responsive === "wideScreen") ? true : (responsive === "desktop");
    const filtered = sortFn(asc, sortKey)(services.filter((a) => {
        const closed = equals(a.Status, new ServiceStatus(2, []));
        let inSearchStr;
        const contains = (str) => strIContains(searchStr, str);
        inSearchStr = ((((contains(a.VismaOrder) ? true : contains(a.MachineCode)) ? true : contains(a.MachineName)) ? true : contains(a.Customer)) ? true : contains(a.Description));
        if (isNullOrWhiteSpace(searchStr) ? true : inSearchStr) {
            if (!closed) {
                return true;
            }
            else {
                return showClosed;
            }
        }
        else {
            return false;
        }
    }));
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((filtered.length < nextTakeCount) ? (filtered.length - rowsToSkip) : rowsPerPage);
    const empty = !loading && (services.length === 0);
    const isCustomer = defaultArg(map((sess) => {
        if (!sess.IsAdmin) {
            return !sess.IsPtg;
        }
        else {
            return false;
        }
    }, ctx.Session), true);
    const th$0027 = (key_1, text) => {
        let elements_1;
        const active = key_1 === sortKey;
        return MuiHelpers_createElement(TableCell, [["variant", "head"], (elements_1 = [MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (_arg) => {
            patternInput_2[1](!asc);
            patternInput_3[1](key_1);
        }]), delay(() => append(singleton(["active", active]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => {
            let elements;
            return singleton((elements = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["sx", {
                lineHeight: 1.58,
                fontWeight: 500,
            }], ["children", text]])], ["children", reactApi.Children.toArray(Array.from(elements))]));
        })))))))))], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
    };
    const headers = toArray(delay(() => append(singleton(th$0027("Severity", ctx.Locale.t("Ticket.Severity.Severity"))), delay(() => append(singleton(th$0027("PlannedDate", ctx.Locale.t("Date"))), delay(() => append(singleton(th$0027("Type", ctx.Locale.t("Services.ServiceType"))), delay(() => append(singleton(th$0027("Description", ctx.Locale.t("Desc"))), delay(() => append((target.tag === 0) ? singleton(th$0027("Customer", ctx.Locale.t("Company"))) : singleton(defaultOf_1()), delay(() => append((target.tag === 2) ? singleton(defaultOf_1()) : singleton(th$0027("MachineName", ctx.Locale.t("Machine"))), delay(() => append(singleton(th$0027("Status", ctx.Locale.t("Ticket.Status.Status"))), delay(() => append(singleton(th$0027("VismaOrder", "Visma #")), delay(() => (isCustomer ? singleton(actionHeader(false, ctx.Locale.t("Confirm"))) : singleton(actionHeader(false, ctx.Locale.t("Edit"))))))))))))))))))))));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        rowGap: 20 + "px",
    }], (elems_13 = toList(delay(() => {
        let elems_3;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems_3 = toList(delay(() => {
            let elems_2;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                columnGap: 20 + "px",
                flexGrow: 1,
            }], (elems_2 = [createElement(Components_Searchbar_25F45B5E, {
                placeholder: ctx.Locale.t("Services.New"),
                onChange: (keyEvent) => {
                    patternInput_1[1](keyEvent.target.value);
                },
                sx: some({
                    flexBasis: 320 + "px",
                }),
            }), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Services.IncludeClosed")], ["checked", showClosed], ["onChange", (e) => {
                patternInput[1](e.target.checked);
            }], ["control", MuiHelpers_createElement(Checkbox, [["color", "primary"]])]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => (!isCustomer ? singleton(createElement(Components_Button_Z1043B8E, {
                text: ctx.Locale.t("Services.New"),
                onClick: (_arg_1) => {
                    addCallback();
                },
                startIcon: (props_6) => {
                    const props_8 = createObj(props_6);
                    return react.createElement(Add, props_8);
                },
            })) : empty_1())));
        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
            let children_6, elements_9, children_1, children_5;
            return append(singleton((children_6 = singleton_1(MuiHelpers_createElement(Table_1, [(elements_9 = [(children_1 = singleton_1(MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(headers))]])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_5 = toList(delay(() => {
                let children_2;
                return loading ? skeletonRows(headers.length, 4) : (empty ? singleton((children_2 = singleton_1(MuiHelpers_createElement(TableCell, [["colSpan", headers.length], ["size", "small"], ["variant", "body"], ["align", "center"], ["children", ctx.Locale.t("Services.NoPlanned")]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]))) : singleton(map_1((st) => {
                    let elements_7;
                    const activityTypeStr = defaultArg(map((t) => ServiceType__ToString_12C6553D(t, ctx.Language), st.Type), ctx.Locale.t("Other"));
                    const plannedDate = parse(st.PlannedDate);
                    const customerOpt = (target.tag === 0) ? tryFind((c) => (c.Id === st.CustomerId), target.fields[1]) : undefined;
                    return MuiHelpers_createElement(TableRow, [["hover", true], (elements_7 = toList(delay(() => {
                        let $key519510FE;
                        return append(singleton(MuiHelpers_createElement(TableCell, [["children", createElement("div", {
                            style: {
                                display: "flex",
                            },
                            children: ($key519510FE = (`activity-${st.Id}-severity`), createElement(Components_Chip_51BC9844, {
                                key: $key519510FE,
                                $key: $key519510FE,
                                primary: Tickets_Severity__ToString_12C6553D(st.Severity, ctx.Language),
                                enabled: true,
                                color: Tickets_Severity__get_ColorCode(st.Severity),
                                backgroundColor: Tickets_Severity__get_BackgroundColor(st.Severity),
                                startIcon: (props_12) => {
                                    const props_14 = createObj(props_12);
                                    return react.createElement(Warning, props_14);
                                },
                            })),
                        })]])), delay(() => append(singleton(td(false, toDateOnlyStr(ctx.DateFnsLocale, plannedDate))), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["style", {
                            maxWidth: 10 + "ch",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }], ["title", activityTypeStr], ["children", activityTypeStr]])), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["style", {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: 60 + "ch",
                        }], ["title", st.Description], ["children", st.Description]])), delay(() => {
                            let matchValue_2, customer, elements_5;
                            return append((matchValue_2 = customerOpt, (matchValue_2 != null) ? ((customer = matchValue_2, singleton(MuiHelpers_createElement(TableCell, [["style", {
                                maxWidth: 20 + "ch",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }], ["title", customer.Name], ["size", "small"], ["variant", "body"], (elements_5 = [MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["customer", int32ToString(customer.Id)]), 1)], ["children", customer.Name]])], ["children", reactApi.Children.toArray(Array.from(elements_5))])])))) : (empty_1())), delay(() => append((target.tag === 2) ? singleton(defaultOf_1()) : singleton(td(false, MuiHelpers_createElement(Link, [["href", RouterModule_encodeParts(ofArray(["customer", int32ToString(st.CustomerId), "machine", int32ToString(st.MachineId)]), 1)], ["children", Machine_getNameOrCode({
                                code: st.MachineCode,
                                name: st.MachineName,
                            })]]))), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["children", createElement("div", {
                                style: {
                                    display: "flex",
                                },
                                children: createElement(Activities_StatusChip_2E7B7895, st),
                            })]])), delay(() => append(singleton(td(false, defaultArg(tryStr(st.VismaOrder), "-"))), delay(() => {
                                let children_4, $key53592071;
                                return isCustomer ? singleton(iconCell([createElement(ConfirmDateButton, {
                                    service: st,
                                    callback: updateCallback,
                                })])) : singleton(iconCell([(children_4 = ofArray([($key53592071 = (`activity-${st.Id}`), createElement(Components_ActivityEditButton_Z48ACC4F1, {
                                    key: $key53592071,
                                    $key: $key53592071,
                                    service: st,
                                    onUpdate: updateCallback,
                                })), createElement(DeleteButton, {
                                    key: "delete-activity-button",
                                    $key: "delete-activity-button",
                                    service: st,
                                    onClose: deleteCallback,
                                })]), MuiHelpers_createElement(ButtonGroup, [["children", reactApi.Children.toArray(Array.from(children_4))]]))]));
                            }))))))));
                        }))))))));
                    })), ["children", reactApi.Children.toArray(Array.from(elements_7))])]);
                }, filtered.slice(rowsToSkip, (rowsToSkip + rowsToTake) + 1))));
            })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_9))])])), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_6))]]))), delay(() => ((services.length < rowsPerPage) ? singleton(defaultOf_1()) : singleton(MuiHelpers_createElement(TablePagination, [["component", "div"], ["count", filtered.length], ["page", page], ["rowsPerPage", rowsPerPage], ["rowsPerPageOptions", Array.from(rowsPerPageOptions)], ["onPageChange", ((arg10$0040, newPage) => {
                onPageChange(setPage, arg10$0040, newPage);
            })], ["onRowsPerPageChange", (ev) => {
                const newRowsPerPage = ev.target.value | 0;
                setPage(0);
                patternInput_5[1](newRowsPerPage);
            }]])))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

